import { useLocation } from 'react-router-dom';
import BottomTabBar from './BottomTabBar';
import SideNav from './SideNav';

// Routes where bottom bar should be hidden (deep-focus screens).
// Each entry is a regex tested against location.pathname.
const HIDE_BOTTOM_BAR = [
  /^\/notes\/.+/,           // Writing a SOAP note — full focus
  /^\/login/,
  /^\/lite($|\/)/,          // Lite has its own minimal nav
  /^\/us($|\/)/,
  /^\/privacy/,             // Public legal pages
  /^\/terms/,
  /^\/hipaa/,
  /^\/resources\/[^/]+\/?$/, // Public article view
];

const HIDE_SIDE_NAV = HIDE_BOTTOM_BAR; // Same rules — keep deep-focus consistent

export default function AppShell({ children, user }) {
  const location = useLocation();
  const hideBottom = HIDE_BOTTOM_BAR.some((re) => re.test(location.pathname));
  const hideSide = HIDE_SIDE_NAV.some((re) => re.test(location.pathname));

  return (
    <>
      {!hideSide && <SideNav user={user} />}
      <div
        // Reserve space for desktop sidebar (md:pl-60) and mobile bottom bar.
        // Bottom bar is now taller (lifted above Emergent badge) → pb-32 on mobile.
        className={`
          ${!hideSide ? 'md:pl-60' : ''}
          ${!hideBottom ? 'pb-32 md:pb-0' : ''}
        `}
      >
        {children}
      </div>
      {!hideBottom && <BottomTabBar user={user} />}
    </>
  );
}
